/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { CookieConsent } from "@/src/types/CookieConsent";

/**
 * Important: only create functions in here which reads or checks data from local storage. If you need to write data, create it
 * in CookieConsentProvider, because in this case the app needs to know about the state change.
 * */

export function getConsent() {
  const consentJSON = localStorage.getItem("consent");
  if (!consentJSON) {
    return null;
  }
  return JSON.parse(consentJSON) as CookieConsent;
}

export function hasConsent(key: keyof NonNullable<CookieConsent["config"]>, injectedConsent?: CookieConsent) {
  let consent = injectedConsent;

  if (!injectedConsent) {
    consent = getConsent() ?? undefined;
  }

  switch (consent?.consentType) {
    case "deny":
      return false;
    case "allow":
      return true;
    case "configured":
      return consent?.config?.[key] ?? false;
    default:
      return false;
  }
}
